import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store/app";
import {
  CompanyDetails,
  getCompanyManagementList,
} from "../../../store/CompanyManagementSlice";
import ToolBar from "../../../components/ToolBar";
import { Button } from "antd";
import FilterForm from "./Component/FilterForm";
import ListComponent from "./Component/ListComponent";
import AddComponent from "./Component/AddComponent";
import EditComponent from "./Component/EditComponent";
import BulkAdd from "./Component/BulkAdd";
import DeleteCompanyManagement from "./Component/DeleteCoponent";
import ExportForm from "./Component/ExportForm";

const CompanyManagement: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const [listData, setListData] = useState<any>();
  const [totalData, setTotalData] = useState<any>(0);
  const [visible, setVisible] = useState<boolean>(false);
  const [savePayload, setSavePayload] = useState<any>();
  const [loading, setLoading] = useState(true);
  const [openCsvModal, setOpenCsvModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [editData, setEditData] = useState();
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [openDeleteData, setOpenDeleteData] = useState<any>();
  const [paginationData, setPaginationData] = useState<any>({
    page_number: 1,
    page_size: 10,
  });
  const [exportDrawer, setExportDrawer] = useState<boolean>(false);
  const getList = useCallback(
    (data?: any) => {
      setLoading(true);
      const payload = {
        ...data,
        page_number: data?.page_number ?? 1,
        page_size: data?.page_size ?? 10,
      };
      setSavePayload(payload);
      dispatch(getCompanyManagementList(payload))
        .then((res: any) => {
          setListData(res?.data?.indexedResults);
          setTotalData(res?.data?.totalRecords);
          setLoading(false);
        })
        .catch(() => {
          setListData([]);
          setTotalData(0);
          setLoading(false);
        });
    },
    [dispatch]
  );

  const openAddModal = () => {
    setVisible(true);
  };

  const closeAddModal = () => {
    setVisible(false);
  };

  const handleCsvModal = () => {
    setOpenCsvModal(true);
  };

  const closeCsvModal = () => {
    setOpenCsvModal(false);
  };

  const getDetailsData = (data: any) => {
    const payload = {
      id: data.main_id,
    };
    dispatch(CompanyDetails(payload))
      .then((res: any) => {
        setEditData(res.data);
        setEditModal(true);
      })
      .catch(() => {
        setEditModal(false);
      });
  };

  const handleEditModal = (data: any) => {
    getDetailsData(data);
  };

  const closeEditModal = () => {
    setEditModal(false);
  };

  useEffect(() => {
    getList();
  }, [getList]);

  const handleDeleteModal = (data: any) => {
    setOpenDeleteModal(true);
    setOpenDeleteData(data);
  };
  const handleDeleteRequestClose = () => {
    setOpenDeleteModal(false);
    setOpenDeleteData(null);
  };

  const openExportDrawer = () => {
    setExportDrawer(true);
  };
  const closeExportDrawer = () => {
    setExportDrawer(false);
  };
  return (
    <>
      <ToolBar
        title={"Company Management"}
        children={
          <>
            <Button type="primary" onClick={openAddModal}>
              Add New
            </Button>
            <Button type="default" onClick={openExportDrawer}>
              Export
            </Button>
            <Button type="default" onClick={handleCsvModal}>
              Bulk Add
            </Button>
          </>
        }
      />
      <FilterForm getList={getList} setPaginationData={setPaginationData} />
      <ListComponent
        listData={listData}
        setListData={setListData}
        totalData={totalData}
        tableloading={loading}
        setTableLoading={setLoading}
        paginationData={paginationData}
        setPaginationData={setPaginationData}
        getList={getList}
        handleEditModal={handleEditModal}
        savePayload={savePayload}
        handleDeleteModal={handleDeleteModal}
      />
      <AddComponent visible={visible} close={closeAddModal} getList={getList} />
      <EditComponent
        visible={editModal}
        close={closeEditModal}
        editData={editData}
        getList={getList}
      />
      <BulkAdd close={closeCsvModal} visible={openCsvModal} getList={getList} />
      <DeleteCompanyManagement
        open={openDeleteModal}
        deleteValues={openDeleteData}
        title={openDeleteData?.company_name}
        close={handleDeleteRequestClose}
        name={"Company Name"}
        getList={getList}
        setPaginationData={setPaginationData}
        savePayload={savePayload}
      />
      {exportDrawer && (
        <ExportForm
          visible={exportDrawer}
          close={closeExportDrawer}
          savePayload={savePayload}
        />
      )}
    </>
  );
};

export default CompanyManagement;
